async function blobToAudioBuffer(blob, context) {
  const arrayBuffer = await blob?.arrayBuffer()
  return await context?.decodeAudioData(arrayBuffer)
}

export default blobToAudioBuffer
